import { AjaxRequest, ajax } from 'rxjs/ajax';
import { StateObservable } from 'redux-observable';
import get from 'lodash/get';
import omit from 'lodash/omit';
import some from 'lodash/some';
import isString from 'lodash/isString';

import { forEach } from 'lodash-es';

// import i18n from './i18n';

// eslint-disable-next-line import/prefer-default-export
export const isPhoneNumber = (value: string) => {
	if (!value) {
		return false;
	}
	return true;
};
export const queryParam = (obj: any): string => {
	const a = `?${new URLSearchParams(obj).toString()}`;
	// const keys = Object.keys(obj);
	// forEach(keys, (k) => {
	// 	a += `${get(obj, 'k', '')}`;
	// });
	// return a === '?' ? '' : a;
	return a;
};
